import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBWTTKvUhqPIndHn2x9vJjYlevdmONb7Dw",
  authDomain: "only100-5d07b.firebaseapp.com",
  projectId: "only100-5d07b",
  storageBucket: "only100-5d07b.firebasestorage.app",
  messagingSenderId: "627995478292",
  appId: "1:627995478292:web:465b20b354faf03453da01"
};

const APP_CHECK_SITE_KEY = "6LcpqcktAAAAAEdSrLOyUJnBd4_aEQmeIdp6w6ZU";

const app = initializeApp(firebaseConfig);

if (typeof window !== "undefined") {
  // ReCaptchaEnterpriseProvider is always the provider. A debug token is
  // assigned only in development. Production builds inline NODE_ENV, so this
  // branch is removed and the token string is not shipped.
  if (process.env.NODE_ENV === "development") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = "A576F5F3-308E-473B-92DD-AC6111208771";
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(APP_CHECK_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export default app;